import { Controller } from "@hotwired/stimulus"

/**
 * Searchbar Controller
 *
 * Mobile: toggles search field visibility on click, closes on click outside
 * All screens: shows/hides clear button based on input value, clears and submits form
 */
export default class extends Controller {
  static targets = ["field", "icon", "input", "clearButton", "form"]

  toggle() {
    this.fieldTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("hidden")

    if (!this.fieldTarget.classList.contains("hidden")) {
      this.inputTarget.focus()
    }
  }

  closeOnClickOutside(event) {
    if (window.innerWidth >= 1024) return
    if (this.element.contains(event.target)) return
    if (this.fieldTarget.classList.contains("hidden")) return

    this.fieldTarget.classList.add("hidden")
    this.iconTarget.classList.remove("hidden")
  }

  clear() {
    this.inputTarget.value = ""
    this.hideClearButton()
    this.formTarget.requestSubmit()
  }

  updateClearButton() {
    if (this.inputTarget.value.trim() === "") {
      this.hideClearButton()
    } else {
      this.showClearButton()
    }
  }

  showClearButton() {
    this.clearButtonTarget.classList.remove("opacity-0")
    this.clearButtonTarget.classList.add("opacity-100")
  }

  hideClearButton() {
    this.clearButtonTarget.classList.remove("opacity-100")
    this.clearButtonTarget.classList.add("opacity-0")
  }
}
